import { render, staticRenderFns } from "./PlatformBilling.vue?vue&type=template&id=025a604a"
import script from "./PlatformBilling.vue?vue&type=script&lang=js"
export * from "./PlatformBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports